<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="detail-bg"></div>
    <div class="container banner2">
      <div class="banner-box">
        <div class="title">
          <span>{{ $t('add.aboutus') }}</span>
        </div>
        <div class="title sub">
          <span>{{ $t('add.company') }}</span>
        </div>
        <div class="des">
          {{ $t('add.text1') }}
        </div>
        <el-button
          class="default block"
          style="margin-top: 0.2rem"
          @click="handleLink('https://help.krazefootball.com/')"
          >{{ $t('add.whitepaper') }}</el-button
        >
        <div class="title sub">
          <span>{{ $t('add.text2') }}</span>
        </div>
        <div class="list6">
          <div class="item">
            <div
              class="avater"
              :style="{
                backgroundImage: 'url(' + avatar1 + ')'
              }"></div>
            <div class="name">{{ $t('add.text3') }}</div>
            <div class="des">
              {{ $t('add.text4') }}
            </div>
          </div>
          <div class="item">
            <div
              class="avater"
              :style="{
                backgroundImage: 'url(' + avatar2 + ')'
              }"></div>
            <div class="name">{{ $t('add.text5') }}</div>
            <div class="des">
              {{ $t('add.text6') }}
            </div>
          </div>
        </div>
        <div class="title sub">
          <span>{{ $t('add.text7') }}</span>
        </div>
        <ul class="milestone-box">
          <li>
            <div class="year">2022/02</div>
            <div class="des">
              <p>{{ $t('add.text8') }}</p>
            </div>
          </li>
          <li>
            <div class="year">2022/05</div>
            <div class="des">
              <p>{{ $t('add.text9') }}</p>
            </div>
          </li>
          <li>
            <div class="year">2022/06</div>
            <div class="des">
              <p>{{ $t('add.text10') }}</p>
            </div>
          </li>
          <li>
            <div class="year">2022/07</div>
            <div class="des">
              <p>{{ $t('add.text11') }}</p>
            </div>
          </li>
          <li>
            <div class="year">2022/08</div>
            <div class="des">
              <p>{{ $t('add.text12') }}</p>
            </div>
          </li>
          <li>
            <div class="year">2022/10</div>
            <div class="des">
              <p>
                {{ $t('add.text13') }}
              </p>
            </div>
          </li>
          <li>
            <div class="year">2022/11 12</div>
            <div class="des">
              <p>
                {{ $t('add.text14') }}
              </p>
            </div>
          </li>
          <li>
            <div class="year">2023</div>
            <div class="des">
              <p>{{ $t('add.text15') }}</p>
            </div>
          </li>
        </ul>
        <div class="title sub">
          <span>{{ $t('add.news') }}</span>
        </div>
        <div class="list1" v-if="newsList && newsList.length > 0">
          <div class="item" v-for="(item, index) in newsList" :key="index">
            <div class="text text2">
              <a :href="item.url" target="_blank">
                <div class="tit">{{ item.name }}</div>
                <div class="cont">{{ item.abstract }}</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { postNews } from '@/api/user'

export default {
  name: 'UserAboutUs',
  components: {},
  watch: {
    '$i18n.locale'() {
      this.init()
    }
  },
  data() {
    return {
      newsList: [],
      currentIndex: 0,
      avatar1: require('@/assets/images/avatar1.png'),
      avatar2: require('@/assets/images/avatar2.png')
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      postNews().then((res) => {
        this.newsList = res.data
      })
    },
    handleRoute(path, tabIndex) {
      if (tabIndex) {
        this.$router.push({ path: path, query: { tabIndex: tabIndex } })
      } else {
        this.$router.push({ path: path })
      }
    },
    handleLink(url) {
      window.open(url, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/aboutus.vue